var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},_vm._l((_vm.items),function(i){return _c('div',{key:i.i,staticClass:"item",style:({ transform: ("translate(" + (i.px) + "px, " + (i.py) + "px)"), opacity: i.opacity })},[_vm._v(_vm._s(_vm.emoji))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }